<div role="status" class="w-full bg-red py-2 text-center text-xl text-white">
    Viewing the dashboard as {{ impersonatedUser()?.email }}, read-only.
</div>
